// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/over-the-rainbow-c.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const overTheRainbowC: Score = {
  slug: "over-the-rainbow-c",
  n: 7,
  title: "Over the Rainbow \u2014 C Major",
  composer: "Harold Arlen",
  rights: "in-copyright",
  publicSafe: false,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 76,
  staves: 1,
  clefs: ["treble"],
  bars: 33,
  barQuarters: 4.0,
  lowest: 57,
  highest: 74,
  hasLyrics: true,
  jasonNote: "One of the most interesting melodies you will hear! Get used to the intervals in the song. Take your time learning it on the Piano in the key of C Major. Watch the movie 'Wizard of Oz' for inspiration!",
  teaches: ["the octave leap", "wide interval reading", "long phrase shaping"],
  art: "/sight-reading/art/over-the-rainbow-c.jpg",
  artRights: "studio",
  background: "/sight-reading/bg/over-the-rainbow-c.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "Some" },
    { bar: 1, hand: "rh", start: 2.0, dur: 2.0, midi: 72, pitch: "C5", d: "half", lyric: "where" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter", lyric: "o" },
    { bar: 2, hand: "rh", start: 5.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "ver" },
    { bar: 2, hand: "rh", start: 5.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "the" },
    { bar: 2, hand: "rh", start: 6.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter", lyric: "Rain" },
    { bar: 2, hand: "rh", start: 7.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter", lyric: "bow" },
    { bar: 3, hand: "rh", start: 8.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "way" },
    { bar: 3, hand: "rh", start: 10.0, dur: 2.0, midi: 69, pitch: "A4", d: "half", lyric: "up" },
    {
  bar: 4,
  hand: "rh",
  start: 12.0,
  dur: 4.0,
  midi: 67,
  pitch: "G4",
  d: "whole",
  lyric: "high.."
},
    {
  bar: 5,
  hand: "rh",
  start: 16.0,
  dur: 2.0,
  midi: 57,
  pitch: "A3",
  d: "half",
  lyric: "there's"
},
    { bar: 5, hand: "rh", start: 18.0, dur: 2.0, midi: 65, pitch: "F4", d: "half", lyric: "a" },
    {
  bar: 6,
  hand: "rh",
  start: 20.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "land"
},
    { bar: 6, hand: "rh", start: 21.0, dur: 0.5, midi: 60, pitch: "C4", d: "eighth", lyric: "that" },
    { bar: 6, hand: "rh", start: 21.5, dur: 0.5, midi: 62, pitch: "D4", d: "eighth", lyric: "i've" },
    {
  bar: 6,
  hand: "rh",
  start: 22.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "heard"
},
    { bar: 6, hand: "rh", start: 23.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "of" },
    {
  bar: 7,
  hand: "rh",
  start: 24.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "once"
},
    { bar: 7, hand: "rh", start: 25.0, dur: 0.5, midi: 59, pitch: "B3", d: "eighth", lyric: "in" },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 60, pitch: "C4", d: "eighth", lyric: "a" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", lyric: "lu" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "lla" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole", lyric: "by" },
    { bar: 9, hand: "rh", start: 32.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "Some" },
    { bar: 9, hand: "rh", start: 34.0, dur: 2.0, midi: 72, pitch: "C5", d: "half", lyric: "where" },
    { bar: 10, hand: "rh", start: 36.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter", lyric: "o" },
    { bar: 10, hand: "rh", start: 37.0, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "ver" },
    { bar: 10, hand: "rh", start: 37.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "the" },
    {
  bar: 10,
  hand: "rh",
  start: 38.0,
  dur: 1.0,
  midi: 71,
  pitch: "B4",
  d: "quarter",
  lyric: "rain"
},
    {
  bar: 10,
  hand: "rh",
  start: 39.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  lyric: "bow"
},
    { bar: 11, hand: "rh", start: 40.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "blue" },
    { bar: 11, hand: "rh", start: 42.0, dur: 2.0, midi: 69, pitch: "A4", d: "half", lyric: "birds" },
    { bar: 12, hand: "rh", start: 44.0, dur: 4.0, midi: 67, pitch: "G4", d: "whole", lyric: "fly" },
    { bar: 13, hand: "rh", start: 48.0, dur: 2.0, midi: 57, pitch: "A3", d: "half", lyric: "and" },
    { bar: 13, hand: "rh", start: 50.0, dur: 2.0, midi: 65, pitch: "F4", d: "half", lyric: "the" },
    {
  bar: 14,
  hand: "rh",
  start: 52.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "dreams"
},
    {
  bar: 14,
  hand: "rh",
  start: 53.0,
  dur: 0.5,
  midi: 60,
  pitch: "C4",
  d: "eighth",
  lyric: "that"
},
    { bar: 14, hand: "rh", start: 53.5, dur: 0.5, midi: 62, pitch: "D4", d: "eighth", lyric: "you" },
    {
  bar: 14,
  hand: "rh",
  start: 54.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "dare"
},
    { bar: 14, hand: "rh", start: 55.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "to" },
    {
  bar: 15,
  hand: "rh",
  start: 56.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "dream"
},
    { bar: 15, hand: "rh", start: 57.0, dur: 0.5, midi: 59, pitch: "B3", d: "eighth", lyric: "re" },
    {
  bar: 15,
  hand: "rh",
  start: 57.5,
  dur: 0.5,
  midi: 60,
  pitch: "C4",
  d: "eighth",
  lyric: "ally"
},
    { bar: 15, hand: "rh", start: 58.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", lyric: "do" },
    {
  bar: 15,
  hand: "rh",
  start: 59.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "come"
},
    {
  bar: 16,
  hand: "rh",
  start: 60.0,
  dur: 3.0,
  midi: 60,
  pitch: "C4",
  d: "half",
  dot: true,
  lyric: "true"
},
    { bar: 16, hand: "rh", start: 63.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 16,
  hand: "rh",
  start: 63.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "some"
},
    { bar: 17, hand: "rh", start: 64.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "day" },
    { bar: 17, hand: "rh", start: 64.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "i" },
    {
  bar: 17,
  hand: "rh",
  start: 65.0,
  dur: 0.5,
  midi: 64,
  pitch: "E4",
  d: "eighth",
  lyric: "wish"
},
    { bar: 17, hand: "rh", start: 65.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "up" },
    { bar: 17, hand: "rh", start: 66.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "on" },
    { bar: 17, hand: "rh", start: 66.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "a" },
    {
  bar: 17,
  hand: "rh",
  start: 67.0,
  dur: 0.5,
  midi: 64,
  pitch: "E4",
  d: "eighth",
  lyric: "star"
},
    {
  bar: 17,
  hand: "rh",
  start: 67.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "wake"
},
    { bar: 18, hand: "rh", start: 68.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "up" },
    {
  bar: 18,
  hand: "rh",
  start: 68.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "where"
},
    { bar: 18, hand: "rh", start: 69.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "the" },
    {
  bar: 18,
  hand: "rh",
  start: 69.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "clouds"
},
    { bar: 18, hand: "rh", start: 70.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "are" },
    { bar: 18, hand: "rh", start: 70.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "far" },
    { bar: 18, hand: "rh", start: 71.0, dur: 0.5, midi: 65, pitch: "F4", d: "eighth", lyric: "be" },
    { bar: 18, hand: "rh", start: 71.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "hi" },
    { bar: 19, hand: "rh", start: 72.0, dur: 2.0, midi: 69, pitch: "A4", d: "half", lyric: "nd" },
    {
  bar: 19,
  hand: "rh",
  start: 74.0,
  dur: 2.0,
  midi: 69,
  pitch: "A4",
  d: "half",
  tie: "start",
  lyric: "me"
},
    {
  bar: 20,
  hand: "rh",
  start: 76.0,
  dur: 3.0,
  midi: 69,
  pitch: "A4",
  d: "half",
  dot: true,
  tie: "stop"
},
    { bar: 20, hand: "rh", start: 79.0, dur: 0.5, rest: true, d: "eighth" },
    {
  bar: 20,
  hand: "rh",
  start: 79.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "Where"
},
    {
  bar: 21,
  hand: "rh",
  start: 80.0,
  dur: 0.5,
  midi: 64,
  pitch: "E4",
  d: "eighth",
  lyric: "trou"
},
    { bar: 21, hand: "rh", start: 80.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "ble" },
    {
  bar: 21,
  hand: "rh",
  start: 81.0,
  dur: 0.5,
  midi: 64,
  pitch: "E4",
  d: "eighth",
  lyric: "melts"
},
    {
  bar: 21,
  hand: "rh",
  start: 81.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "like"
},
    { bar: 21, hand: "rh", start: 82.0, dur: 0.5, midi: 64, pitch: "E4", d: "eighth", lyric: "le" },
    { bar: 21, hand: "rh", start: 82.5, dur: 0.5, midi: 67, pitch: "G4", d: "eighth", lyric: "mon" },
    {
  bar: 21,
  hand: "rh",
  start: 83.0,
  dur: 0.5,
  midi: 64,
  pitch: "E4",
  d: "eighth",
  lyric: "drops"
},
    {
  bar: 21,
  hand: "rh",
  start: 83.5,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "high"
},
    { bar: 22, hand: "rh", start: 84.0, dur: 0.5, midi: 66, pitch: "F#4", d: "eighth", lyric: "a" },
    {
  bar: 22,
  hand: "rh",
  start: 84.5,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  lyric: "bove"
},
    {
  bar: 22,
  hand: "rh",
  start: 85.0,
  dur: 0.5,
  midi: 66,
  pitch: "F#4",
  d: "eighth",
  lyric: "the"
},
    {
  bar: 22,
  hand: "rh",
  start: 85.5,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  lyric: "chim"
},
    {
  bar: 22,
  hand: "rh",
  start: 86.0,
  dur: 0.5,
  midi: 66,
  pitch: "F#4",
  d: "eighth",
  lyric: "ney"
},
    { bar: 22, hand: "rh", start: 86.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth", lyric: "top" },
    {
  bar: 22,
  hand: "rh",
  start: 87.0,
  dur: 0.5,
  midi: 66,
  pitch: "F#4",
  d: "eighth",
  lyric: "that's"
},
    {
  bar: 22,
  hand: "rh",
  start: 87.5,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  lyric: "where"
},
    { bar: 23, hand: "rh", start: 88.0, dur: 2.0, midi: 71, pitch: "B4", d: "half", lyric: "you" },
    { bar: 23, hand: "rh", start: 90.0, dur: 2.0, midi: 71, pitch: "B4", d: "half", lyric: "find" },
    { bar: 24, hand: "rh", start: 92.0, dur: 2.0, midi: 74, pitch: "D5", d: "half" },
    {
  bar: 24,
  hand: "rh",
  start: 94.0,
  dur: 2.0,
  midi: 69,
  pitch: "A4",
  d: "half",
  tie: "start",
  lyric: "me"
},
    { bar: 25, hand: "rh", start: 96.0, dur: 4.0, midi: 69, pitch: "A4", d: "whole", tie: "stop" },
    { bar: 26, hand: "rh", start: 100.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "Some" },
    {
  bar: 26,
  hand: "rh",
  start: 102.0,
  dur: 2.0,
  midi: 72,
  pitch: "C5",
  d: "half",
  lyric: "where"
},
    { bar: 27, hand: "rh", start: 104.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter", lyric: "o" },
    {
  bar: 27,
  hand: "rh",
  start: 105.0,
  dur: 0.5,
  midi: 67,
  pitch: "G4",
  d: "eighth",
  lyric: "ver"
},
    {
  bar: 27,
  hand: "rh",
  start: 105.5,
  dur: 0.5,
  midi: 69,
  pitch: "A4",
  d: "eighth",
  lyric: "the"
},
    {
  bar: 27,
  hand: "rh",
  start: 106.0,
  dur: 1.0,
  midi: 71,
  pitch: "B4",
  d: "quarter",
  lyric: "Rain"
},
    {
  bar: 27,
  hand: "rh",
  start: 107.0,
  dur: 1.0,
  midi: 72,
  pitch: "C5",
  d: "quarter",
  lyric: "bow"
},
    { bar: 28, hand: "rh", start: 108.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "way" },
    { bar: 28, hand: "rh", start: 110.0, dur: 2.0, midi: 69, pitch: "A4", d: "half", lyric: "up" },
    {
  bar: 29,
  hand: "rh",
  start: 112.0,
  dur: 4.0,
  midi: 67,
  pitch: "G4",
  d: "whole",
  lyric: "high.."
},
    { bar: 30, hand: "rh", start: 116.0, dur: 2.0, midi: 57, pitch: "A3", d: "half", lyric: "and" },
    { bar: 30, hand: "rh", start: 118.0, dur: 2.0, midi: 65, pitch: "F4", d: "half", lyric: "the" },
    {
  bar: 31,
  hand: "rh",
  start: 120.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "dreams"
},
    {
  bar: 31,
  hand: "rh",
  start: 121.0,
  dur: 0.5,
  midi: 60,
  pitch: "C4",
  d: "eighth",
  lyric: "that"
},
    {
  bar: 31,
  hand: "rh",
  start: 121.5,
  dur: 0.5,
  midi: 62,
  pitch: "D4",
  d: "eighth",
  lyric: "you"
},
    {
  bar: 31,
  hand: "rh",
  start: 122.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "dare"
},
    {
  bar: 31,
  hand: "rh",
  start: 123.0,
  dur: 1.0,
  midi: 65,
  pitch: "F4",
  d: "quarter",
  lyric: "to"
},
    {
  bar: 32,
  hand: "rh",
  start: 124.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "dream"
},
    { bar: 32, hand: "rh", start: 125.0, dur: 0.5, midi: 59, pitch: "B3", d: "eighth", lyric: "re" },
    {
  bar: 32,
  hand: "rh",
  start: 125.5,
  dur: 0.5,
  midi: 60,
  pitch: "C4",
  d: "eighth",
  lyric: "ally"
},
    {
  bar: 32,
  hand: "rh",
  start: 126.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "do"
},
    {
  bar: 32,
  hand: "rh",
  start: 127.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "come"
},
    {
  bar: 33,
  hand: "rh",
  start: 128.0,
  dur: 4.0,
  midi: 60,
  pitch: "C4",
  d: "whole",
  lyric: "true"
},
  ],
};
